module.exports = __webpack_public_path__ + "img/small_group.d6422e3c.png";